import { ModalProps } from 'react-bootstrap/Modal';

export const isMobile = (): boolean => {
  const mobileBreakPoint: number = 576;
  return window.innerWidth <= mobileBreakPoint;
};

export const isPresent = (obj: unknown): boolean => {
  return obj !== undefined && obj !== null;
};

export const isString = (obj: unknown): obj is string => {
  return typeof obj === 'string';
};

export const isArray = (obj: unknown): obj is unknown[] => {
  return Array.isArray(obj);
};

export const isFunction = (obj: unknown): obj is (...args: unknown[]) => unknown => {
  return typeof obj === 'function';
};

export const isJson = (obj: unknown): boolean => {
  try {
    JSON.parse(obj as string);
    return true;
  } catch {
    return false;
  }
};

export function notBlank(obj: unknown): boolean {
  return obj !== undefined && obj !== null && (obj + '').trim() !== '';
}

export function isBlank(obj: unknown): boolean {
  return obj === undefined || obj === null || (obj + '').trim() === '';
}

export function isDefined(obj: unknown): obj is NonNullable<unknown> {
  return obj !== undefined && obj !== null;
}

export function objIsNotEmpty(obj: unknown): boolean {
  if (typeof obj === 'undefined' || obj === null) {
    return false;
  }
  return Object.keys(obj as object).length > 0;
}

export function notDefined(obj: unknown): obj is null | undefined {
  return obj === undefined || obj === null;
}

export function isObject(val: unknown): val is object {
  return val instanceof Object;
}

export function isNotObject(val: unknown): boolean {
  return !(val instanceof Object);
}

export function arrayNotEmpty(obj: unknown[]): boolean {
  return Array.isArray(obj) && obj.length > 0;
}

export function arrayIsEmpty(obj?: unknown[] | null): boolean {
  return obj === undefined || obj === null || (Array.isArray(obj) && obj.length === 0);
}

export const fullScreenModal = () => {
  return window.innerWidth < 1200 ? true : (undefined as ModalProps['fullscreen']);
};
